import { validate as validateUUID } from "uuid"

export const isValidUUID = (id: string | undefined): boolean => {
  if (!id) {
    return false
  }
  return validateUUID(id)
}